module.exports = __webpack_public_path__ + "static/img/logout-hover.09da4182.png";